export class TelemedicineAccessStruct  {
    public idPatient: number;
    public idSelfTriagePatient: number;
    public idHealthUnit: number;
}